<template>
  <v-btn
    class="mx-2"
    v-bind:color="activeDevice ? '' : 'red'"
    @click="emitToggleDevice()"
    :disabled="disabled"
    dark
    fab
    outlined
  >
    <v-icon>{{ activeDevice ? iconName : `${iconName}_off` }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'ButtonDeviceActivation',

  props: {
    disabled: Boolean,
    kind: String,
    activeDevice: Boolean
  },

  data: () => {
    return {
      iconName: ''
    }
  },

  created() {
    if (this.kind === 'audio') this.iconName = 'mic'
    if (this.kind === 'video') this.iconName = 'videocam'
  },

  methods: {
    emitToggleDevice() {
      this.$emit('toggle-device', this.kind)
    }
  }
}
</script>
